
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * FirewallActionType enum
 */
class FirewallActionType {
  /**
   * Initialize enum with a given value
   * @param {FirewallActionType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof FirewallActionType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!FirewallActionType}
   * @param {!FirewallActionType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof FirewallActionType)) {
      throw new TypeError('Instance of FirewallActionType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!FirewallActionType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!FirewallActionType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === FirewallActionType.BLOCK.value) {
      return 'BLOCK'
    }
    if (this.value === FirewallActionType.PERMIT.value) {
      return 'PERMIT'
    }
    if (this.value === FirewallActionType.PERMIT_FORCE.value) {
      return 'PERMIT_FORCE'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!FirewallActionType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!FirewallActionType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!FirewallActionType} Created enum
   */
  static fromObject (other) {
    return new FirewallActionType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
FirewallActionType.BLOCK = new FirewallActionType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
FirewallActionType.PERMIT = new FirewallActionType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
FirewallActionType.PERMIT_FORCE = new FirewallActionType(0 + 2)

export { FirewallActionType };

/**
 * Fast Binary Encoding FirewallActionType field model
 */
class FieldModelFirewallActionType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelFirewallActionType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelFirewallActionType}
   * @param {FirewallActionType=} defaults Default value, defaults is new FirewallActionType()
   * @returns {!FirewallActionType} Result value
   */
  get (defaults = new FirewallActionType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new FirewallActionType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelFirewallActionType}
   * @param {!FirewallActionType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelFirewallActionType };
